/* eslint-disable no-inner-declarations */
// IBG — assign the inner <img> src as the container background-image, but only when the
// element nears the viewport. Previously every .ibg background was set at load, which
// eagerly downloaded all of them at once. IntersectionObserver defers off-screen ones.
(function () {
  const ibgEls = document.querySelectorAll('.ibg');
  if (!ibgEls.length) return;

  const apply = item => {
    const img = item.querySelector('img');
    const src = img && img.getAttribute('src');
    if (src) item.style.backgroundImage = `url(${src})`;
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            apply(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
    ibgEls.forEach(item => io.observe(item));
  } else {
    ibgEls.forEach(apply);
  }
})();

function formatDate(date) {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

global.formatDate = formatDate;

function formatDateCustom(date) {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}

global.formatDateCustom = formatDateCustom;

// Динамічний адаптив
let da_elements = document.querySelectorAll('[data-da]');
let parents_original = [];
let attr_elements = [];
let attr_element = [];
let match_media = [];

// Початкова позиція елемента
for (let item of da_elements) {
  let parentChildren = item.parentElement.children;
  for (let i = 0; i < parentChildren.length; i++) {
    if (parentChildren[i] === item) {
      parents_original.push({
        parent: item.parentElement,
        index: i,
      });
    }
  }
}

// Атрибути елементів
for (let item of da_elements) {
  attr_elements.push(item.dataset.da);
}

// Основна подія (за допомогою window.matchMedia - ПОЧАТОК)******** (Спрацьовує тільки тоді, коли проходить через зазначені брейкпоїнти)
// Масив брейкоінтів
for (let i = 0; i < attr_elements.length; i++) {
  match_media.push(window.matchMedia('(max-width:' + attr_elements[i].split(', ')[2] + 'px)'));
  match_media[i].addEventListener('change', dinamic_adapt);
}

function dinamic_adapt() {
  for (let i = 0; i < match_media.length; i++) {
    if (match_media[i].matches) {
      attr_element = attr_elements[i].split(', ');
      document
        .querySelector(`.${attr_element[0]}`)
        .insertBefore(da_elements[i], document.querySelector(`.${attr_element[0]}`).children[attr_element[1]]);
    } else {
      parents_original[i].parent.insertBefore(
        da_elements[i],
        parents_original[i].parent.children[parents_original[i].index]
      );
    }
  }
}
dinamic_adapt(); // також запускаємо функцію окремо для коретного адаптиву при оновленні сторінки

// Основна подія (за допомогою window.matchMedia - КІНЕЦЬ)********

// Open Submenu
let menu_links = document.querySelectorAll('.menu-header__link_submenu');

if (menu_links) {
  menu_links.forEach(function (menu_link) {
    menu_link.addEventListener('click', function (event) {
      event.preventDefault();

      menu_link.classList.toggle('active');
      menu_link.nextElementSibling.classList.toggle('active');
    });
  });
}

// Cities
let cities_tops = document.querySelectorAll('.cities-header__menu');

if (cities_tops) {
  cities_tops.forEach(function (cities_top) {
    cities_top.addEventListener('click', function (event) {
      let cities_label = cities_top.querySelector('.cities-header__link');
      let cities_menu = cities_top.querySelector('.cities-header__submenu');

      cities_label.classList.toggle('active');
      cities_menu.classList.toggle('active');
    });
  });
}

// Burger
let mobile_header = document.querySelector('.mobile-header');
let body = document.querySelector('body');
let burger_icon = document.querySelector('.header__burger');
let header = document.querySelector('.header');

if (burger_icon) {
  burger_icon.addEventListener('click', function (event) {
    event.preventDefault();

    burger_icon.classList.toggle('active');
    body.classList.toggle('lock');
    mobile_header.classList.toggle('active');
    header.classList.toggle('active');
  });
}




// Cities Map Tabs
let cities_tabs_links = document.querySelectorAll('.content-main-cities__link');
let cities_tabs_items = document.querySelectorAll('.content-main-cities__item');
let cities_tabs_maps = document.querySelectorAll('.maps-content-main-cities__map');

if (cities_tabs_links) {
  cities_tabs_links.forEach(function (cities_tabs_link) {
    citiesMapactive(cities_tabs_link);

    cities_tabs_link.addEventListener('click', function (event) {
      event.preventDefault();

      cities_tabs_items.forEach(function (cities_tabs_item) {
        cities_tabs_item.classList.remove('active');
      });

      this.parentElement.classList.add('active');

      citiesMapactive(this);
    });
  });

  function citiesMapactive(element) {
    if (element.parentElement.classList.contains('active')) {
      cities_tabs_maps.forEach(function (cities_tabs_map) {
        cities_tabs_map.classList.remove('active');
      });

      let cities_tab_active = document.querySelector(`.${element.dataset.cities}`);
      cities_tab_active.classList.add('active');
    }
  }
}

//MAPS CITIES ================================================================================================================
// Map Warsaw
if (document.getElementById('cities-map-warsaw')) {
  var map = new google.maps.Map(document.getElementById('cities-map-warsaw'), {
    zoom: 12,
    center: { lat: 52.25224845601914, lng: 21.000078676263755 },
    language: 'pl',
  });

  var marker = new google.maps.Marker({
    position: { lat: 52.25224845601914, lng: 21.000078676263755 },
    map: map,
    title: 'КЛИНИКА ŚRÓDMIEŚCIE',
    icon: {
      url: 'img/icons/map-marker.svg', // шлях до картинки
      scaledSize: new google.maps.Size(35, 35), // розмір картинки
    },
  });

  var secondMarker = new google.maps.Marker({
    position: { lat: 52.221248, lng: 21.035417 },
    map: map,
    title: 'КЛИНИКА MOKOTÓW',
    icon: {
      url: 'img/icons/map-marker.svg', // шлях до картинки
      scaledSize: new google.maps.Size(35, 35), // розмір картинки
    },
  });
}

// Map Wroclaw
if (document.getElementById('cities-map-wroclaw')) {
  var map = new google.maps.Map(document.getElementById('cities-map-wroclaw'), {
    zoom: 12,
    center: { lat: 51.11532535093699, lng: 17.01519711649894 },
    language: 'pl',
  });
}

// Map Poznan
if (document.getElementById('cities-map-poznan')) {
  var map = new google.maps.Map(document.getElementById('cities-map-poznan'), {
    zoom: 12,
    center: { lat: 52.415074779584295, lng: 16.912639786532353 },
    language: 'pl',
  });
}

// Map Tricity
if (document.getElementById('cities-map-tricity')) {
  var map = new google.maps.Map(document.getElementById('cities-map-tricity'), {
    zoom: 12,
    center: { lat: 54.357374133061306, lng: 18.641950107176942 },
    language: 'pl',
  });
}
// ==========================================================================================================================

//MAPS CONTACT ==============================================================================================================

//Maps Contact Warsaw =======================================================================================================
// Map Warsaw-1
if (document.getElementById('contact-map-warsaw-1')) {
  var map = new google.maps.Map(document.getElementById('contact-map-warsaw-1'), {
    zoom: 12,
    center: { lat: 52.25224845601914, lng: 21.000078676263755 },
    language: 'pl',
  });

  var marker = new google.maps.Marker({
    position: { lat: 52.25224845601914, lng: 21.000078676263755 },
    map: map,
    title: 'КЛИНИКА ŚRÓDMIEŚCIE',
    icon: {
      url: 'img/icons/map-marker.svg', // шлях до картинки
      scaledSize: new google.maps.Size(35, 35), // розмір картинки
    },
  });
}
// Map Warsaw-2
if (document.getElementById('contact-map-warsaw-2')) {
  var map = new google.maps.Map(document.getElementById('contact-map-warsaw-2'), {
    zoom: 12,
    center: { lat: 52.221248, lng: 21.035417 },
    language: 'pl',
  });

  var marker = new google.maps.Marker({
    position: { lat: 52.221248, lng: 21.035417 },
    map: map,
    title: 'КЛИНИКА MOKOTÓW',
    icon: {
      url: 'img/icons/map-marker.svg', // шлях до картинки
      scaledSize: new google.maps.Size(35, 35), // розмір картинки
    },
  });
}
// ==========================================================================================================================

//Maps Contact Wroclaw =======================================================================================================
// Map Wroclaw-1
if (document.getElementById('contact-map-wroclaw-1')) {
  var map = new google.maps.Map(document.getElementById('contact-map-wroclaw-1'), {
    zoom: 12,
    center: { lat: 51.11532535093699, lng: 17.01519711649894 },
    language: 'pl',
  });
}
// ==========================================================================================================================

//Maps Contact Poznan =======================================================================================================
// Map Poznan-1
if (document.getElementById('contact-map-poznan-1')) {
  var map = new google.maps.Map(document.getElementById('contact-map-poznan-1'), {
    zoom: 12,
    center: { lat: 52.415074779584295, lng: 16.912639786532353 },
    language: 'pl',
  });
}
// ==========================================================================================================================

//Maps Contact Tricity =======================================================================================================
// Map Tricity-1
if (document.getElementById('contact-map-tricity-1')) {
  var map = new google.maps.Map(document.getElementById('contact-map-tricity-1'), {
    zoom: 12,
    center: { lat: 54.357374133061306, lng: 18.641950107176942 },
    language: 'pl',
  });
}
// ==========================================================================================================================

// ==========================================================================================================================

// Show Contact Map
let searchContactMapForm = document.querySelector('.search-content-main-contact__form');
let searchContactMapInputHidden = document.querySelector('.dropdown__input-hidden');
let searchContactMapItems = document.querySelectorAll('.maps-content-main-contact__items');

if (searchContactMapForm) {
  searchContactMapForm.addEventListener('submit', function (event) {
    event.preventDefault();
  });
}
